import mitt from 'mitt';

// Global event bus to replace Vue 2 $root.$on / $root.$emit patterns.
// Usage:
//   import eventBus from '$utils/eventBus';
//   eventBus.on('my-event', handler);
//   eventBus.emit('my-event', payload);
//   eventBus.off('my-event', handler);

const eventBus = mitt();

export default eventBus;
